import { useEffect } from 'react'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setAvailableCredits } from 'Pods/ThreeDStudio/Store/actions/generation'

function useLoadInitialCredits() {
  const availableCredits = useThreeDStudioStore(state => state.generation.availableCredits)
  const pageConfig = usePageConfig()
  const isLoggedIn = pageConfig?.isCurrentUser ?? false
  const pageConfigAvailableCredits = isLoggedIn && pageConfig.availableCredits

  useEffect(() => {
    if (availableCredits === null && typeof pageConfigAvailableCredits === 'number') {
      setAvailableCredits(pageConfigAvailableCredits)
    }
  }, [availableCredits, pageConfigAvailableCredits])
}

export default useLoadInitialCredits
